// extracted by mini-css-extract-plugin
export var layoutContainer = "_cs-0";
export var layoutContainerNoRounding = "_cs-6";
export var layoutContainerOpen = "_cs-5";
export var layoutContainerResizing = "_cs-1";
export var mainContent = "_cs-2";
export var resizeDivider = "_cs-3";
export var slidePanel = "_cs-4";